import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import Cookies from 'universal-cookie'
import { Link, withRouter } from 'react-router-dom'
import { withAuth } from './AuthContext'
import { withSearch } from './SearchContext'
import { shouldTranslateTo } from '../utils/utils'
import {
  Title,
  Subtitle,
  Button,
  ContainerFlexRow,
  ContainerFlexColumnStart,
  Image,
} from './Utils/CustomClasses'

const queryParams = new URLSearchParams(window.location.search)
const cookies = new Cookies()

const Container = styled.div`
  margin-top: -10px;

  @media screen and (max-width: 768px) and (min-width: 426px) {
    margin-top: -20px;
  }

  @media screen and (max-width: 425px) {
    margin-top: -15px;
  }
`

const Header = styled.div`
  background-color: #f6f0e6;
`

const CustomContainerFlexRow = styled(ContainerFlexRow)`
  justify-content: space-evenly;
  align-items: center;

  @media screen and (max-width: 1024px) {
    flex-direction: row;
  }

  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`

const HeaderText = styled.div`
  max-width: 50vw;
  flex-shrink: 0;

  @media screen and (max-width: 768px) {
    max-width: fit-content;
  }
`

const HeaderImage = styled.div`
  ${(props) => (props.fitImage ? 'height: inherit;' : 'height: 100%;')};
  border-radius: 15px;
  text-align: center;
  ${(props) => props.background && 'background-color: #16494D'};

  img {
    width: ${(props) => (props.width ? props.width : '100%')};
    border-radius: 15px;
    ${(props) => props.fitImage && 'object-fit: cover; height: 100%;'}
  }

  @media screen and (max-width: 1025px) {
    img {
      width: ${(props) => (props.widthMd ? props.widthMd : '100%')};
    }
  }

  @media screen and (max-width: 768px) {
    img {
      width: 100%;
    }
  }
`

const CustomButtom = styled(Button)`
  padding: 18px 86px;
  a {
    padding: unset;
    height: auto;
  }
`

const MapTitle = styled(Title)`
  font-size: 33px;
  margin: 0 auto;
  text-align: center;
`

const MapSubtitle = styled(Title)`
  font-size: 22px;
  font-weight: normal;
  margin: 0 auto;
  text-align: center;
`

const SignupMailingList = (props) => {
  // Component logic goes here
  const [pageText, setPageText] = useState([])

  useEffect(() => {
    localStorage.removeItem('ud')
    cookies.remove('laravelsession')

    if (queryParams.get('ls')) {
      // User has arrived from marketing email. Set cookie for redirecting user to correct step
      cookies.set('ls', queryParams.get('ls'), { path: '/' })
      cookies.set('fem', 'y', { path: '/' })
      cookies.set('cs', '', { path: '/' })
      cookies.set('rdv', '', { path: '/' })
    }
    if (queryParams.get('cs')) {
      // User has arrived from in-email community link.  Set cookie for redirecting user to correct page in community
      cookies.set('cs', queryParams.get('cs'), { path: '/' })
      cookies.set('fem', 'y', { path: '/' })
      cookies.set('ls', '', { path: '/' })
      cookies.set('dc', '', { path: '/' })
      cookies.set('rdv', '', { path: '/' })
    }
    if (queryParams.get('dc')) {
      cookies.set('dc', queryParams.get('dc'), { path: '/' })
      cookies.set('fem', 'y', { path: '/' })
      cookies.set('cs', '', { path: '/' })
      cookies.set('rdv', '', { path: '/' })
    }

    const language = shouldTranslateTo()
    const getPageText = (pageValue, languageValue) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageText = response.data.map((textItem) => {
            return textItem.text
          })

          setPageText(pageText)
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }

    getPageText('login-auth0', language)
  }, [])

  const handleLogin = () => {
    window.open('/auth0/login', '_self')
  }

  if (pageText.length === 0) {
    return (
      <div className="card-body text-center">
        <div
          className="spinner-border homestays-spinner"
          style={{ marginTop: '100px' }}
          role="status"
        >
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    )
  }
  return (
    <>
      <Container>
        <Header>
          <CustomContainerFlexRow
            gap="50px"
            padding="10vh 40px 10vh 5vw"
            paddingSm="5vh 8vw 5vh 8vw"
          >
            <HeaderText>
              <Title
                size="2.5rem"
                sizemd="2.5rem"
                dangerouslySetInnerHTML={{
                  __html: `${pageText[0]}`,
                }}
              ></Title>
              <Subtitle
                size="1.5rem"
                sizemd="1.5rem"
                sizesm="22px"
                margin="40px 0 0 0"
                marginmd="40px 0 0 0"
                dangerouslySetInnerHTML={{
                  __html: `${pageText[1]}`,
                }}
              />
              <Subtitle
                bold
                size="1.3rem"
                sizemd="1rem"
                sizesm="20px"
                margin="30px 0 50px 0"
                marginmd="40px 0 28px 0"
                dangerouslySetInnerHTML={{
                  __html: `${pageText[3]} <a href='/signup'>${pageText[4]}</a>`,
                }}
              />

              <CustomButtom onClick={() => handleLogin()}>
                <Link>{pageText[5]}</Link>
              </CustomButtom>
            </HeaderText>
            <HeaderImage>
              <img src={'/images/facebook-host/header-2.jpg'} />
            </HeaderImage>
          </CustomContainerFlexRow>
        </Header>

        {/* Map */}
        <ContainerFlexRow
          gray
          gap="50px"
          padding="10vh 7vw 10vh 7vw"
          paddingSm="4vh 7vw 6vh 7vw"
          paddingMd="7vh 40px 5vh 6vw"
          gapMd="20px"
        >
          <Image width="45vw" widthMd="40vw">
            <img src="/images/gygu/gygu-home-map-group.png" />
          </Image>
          <ContainerFlexColumnStart gap="30px" center>
            <MapTitle
              dangerouslySetInnerHTML={{
                __html: `The social travel club for <b>over 50s</b>`,
              }}
            ></MapTitle>
            <MapSubtitle
              bold
              size="27px"
              sizemd="22px"
              sizesm="18px"
              dangerouslySetInnerHTML={{
                __html: `Covering <b>28 countries</b> around the world and counting...`,
              }}
            ></MapSubtitle>
          </ContainerFlexColumnStart>
        </ContainerFlexRow>
      </Container>
    </>
  )
}

export default withRouter(withSearch(withAuth(SignupMailingList)))
